import { render, staticRenderFns } from "./TrayVials.vue?vue&type=template&id=ffa16062&scoped=true&"
import script from "./TrayVials.vue?vue&type=script&lang=js&"
export * from "./TrayVials.vue?vue&type=script&lang=js&"
import style0 from "./TrayVials.vue?vue&type=style&index=0&id=ffa16062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa16062",
  null
  
)

export default component.exports